import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import { recipeAdd, recipeList, recipeDelete, recipeUpdate } from '../../helpers/api';
import {
    recipeAddSuccess,
    recipeListSuccess,
    recipeDeleteSuccess,
    recipeUpdateSuccess,
    recipeAddError,
    recipeListError,
    recipeDeleteError,
    recipeUpdateError,
} from './actions';
import { RecipeManagementActionTypes } from './constants';
import { SagaIterator } from 'redux-saga';
import { AxiosResponse } from 'axios';

// Add Recipe
function* recipeAddSaga(action: any): SagaIterator {
    try {
        const response: AxiosResponse = yield call(recipeAdd, action.payload);
        // send the created recipe object, not a message string
        yield put(recipeAddSuccess(response.data.data));
    } catch (error: any) {
        yield put(recipeAddError(error.message || 'Error Occurred'));
    }
}

// Delete Recipe
function* recipeDeleteSaga(action: any): SagaIterator {
    try {
        yield call(recipeDelete, action.payload);
        yield put(recipeDeleteSuccess(action.payload.recipe_id)); // send recipe_id
    } catch (error: any) {
        yield put(recipeDeleteError(error.message || 'Error Occurred'));
    }
}

// List Recipe (only one per item)
function* recipeListSaga(action: any): SagaIterator {
    try {
        const response: AxiosResponse = yield call(recipeList, action.payload);
        const recipe = response.data?.data || null; // single recipe object or null
        yield put(recipeListSuccess(recipe));
    } catch (error: any) {
        yield put(recipeListError(error.message || 'Error Occurred'));
    }
}

// Update Recipe
function* recipeUpdateSaga(action: any): SagaIterator {
    try {
        const response: AxiosResponse = yield call(recipeUpdate, action.payload);
        yield put(recipeUpdateSuccess(response.data.data)); // updated recipe object
    } catch (error: any) {
        yield put(recipeUpdateError(error.message || 'Error Occurred'));
    }
}

// Watchers
function* watchRecipeAdd() {
    yield takeEvery(RecipeManagementActionTypes.RECIPE_ADD, recipeAddSaga);
}

function* watchRecipeList() {
    yield takeEvery(RecipeManagementActionTypes.RECIPE_LIST, recipeListSaga);
}

function* watchRecipeDelete() {
    yield takeEvery(RecipeManagementActionTypes.RECIPE_DELETE, recipeDeleteSaga);
}

function* watchRecipeUpdate() {
    yield takeEvery(RecipeManagementActionTypes.RECIPE_UPDATE, recipeUpdateSaga);
}

// Root Saga
function* recipeManagementSaga() {
    yield all([fork(watchRecipeAdd), fork(watchRecipeDelete), fork(watchRecipeList), fork(watchRecipeUpdate)]);
}

export default recipeManagementSaga;
